export default __webpack_public_path__ + "static/media/lens-blue.ce5bce7f.svg";